export default __webpack_public_path__ + "static/media/52_mobile.228c8ac2.jpg";